import {FC, lazy, Suspense, useState} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {
  isEmpty,
  isNotEmpty,
  newDateUserTimezoneOffset,
  newDateUserTimezoneOffsetMinus,
  WithChildren,
} from '../../_metronic/helpers'
import {AuthorizedFunction} from '../modules/auth/components/AuthorizedFunction'
import PesquisaTemploPage from '../modules/app/management/PesquisaTemploPage'
import TemploPage from '../modules/accounts/TemploPage'
import {useKeycloak} from '@react-keycloak/web'
import {
  getEscalaByTemplo,
  getSimpleMediumByEmail,
} from '../modules/app/management/users-list/core/_requests'
import {useQuery} from 'react-query'
import {toast, ToastContainer} from 'react-toastify'
import {EscalaDevas, Medium, Templo} from '../modules/app/management/users-list/core/_models'
import SalaDevasPage from '../modules/app/management/SalaDevasPage'
import {escape} from 'querystring'
import {array} from 'yup'
import ptBR from 'date-fns/locale/pt-BR'
import {registerLocale} from 'react-datepicker'
import moment from 'moment'

registerLocale('ptBR', ptBR)

const PrivateRoutes = () => {
  const MediumPage = lazy(() => import('../modules/accounts/MediumPage'))
  const FalangePage = lazy(() => import('../modules/falange/FalangePage'))
  const AdjuntoPage = lazy(() => import('../modules/adjunto/AdjuntoPage'))
  const LegiaoPage = lazy(() => import('../modules/legiao/LegiaoPage'))
  const PesquisaMediumPage = lazy(() => import('../modules/app/management/PesquisaMediumPage'))
  const CarteirinhaPage = lazy(
    () => import('../modules/app/management/carteirinha/CarteirinhaPage')
  )
  const PesquisaCarteirinhaPage = lazy(
    () => import('../modules/app/management/carteirinha/PesquisaCarteirinhaPage')
  )
  const AprovacoesFichaPage = lazy(() => import('../modules/app/management/AprovacoesFichaPage'))
  const UsuariosKeycloakPage = lazy(
    () => import('../modules/app/management/usuarios-keycloak/UsuariosKeycloakPage')
  )
  const RelatoriosPage = lazy(() => import('../modules/app/management/relatorios/RelatoriosPage'))

  const {keycloak, initialized} = useKeycloak()
  const is_admin = AuthorizedFunction(['admin-sistema'])
  const is_autorizado = AuthorizedFunction(['admin-sistema', 'autorizador-cadastro'])

  //bloqueia a renderização das rotas privadas até a validação de acesso concluir
  const [acesso, setAcesso] = useState<'validando' | 'liberado' | 'negado'>('validando')
  const [mensagemNegado, setMensagemNegado] = useState('')

  //valida cadastro usuário na base
  var email_login = keycloak?.tokenParsed?.email

  const {data: usuario} = useQuery(
    `user-${email_login}`,
    () => {
      if (email_login === undefined) {
        return null
      }
      var has_message = ''
      var error: boolean = false
      var escala_valida: boolean = false
      var is_presidente: boolean = false

      validarAcesso(email_login, has_message, error, is_presidente, escala_valida)
        .then(validarTemploAtivo)
        .then(validarEscalado)
        .then(validarEscala)
        .then(lancarError)
    },
    {
      onError: (err) => {
        console.error(err)
      },
    }
  )

  function validarAcesso(
    email_login: string,
    has_message: string,
    error: boolean,
    is_presidente: boolean,
    escala_valida: boolean
  ) {
    return new Promise((resolve, reject) => {
      getSimpleMediumByEmail(email_login).then((user) => {
        if (isEmpty(user?.id_medium)) {
          has_message = 'Usuário sem email cadastrado! Entre em contato com Administrador'
          error = true
        }
        if (!error && user?.in_filho_devas !== 1) {
          has_message = 'Usuário não é Filho(a) de Devas!'
          error = true
        }

        if (
          user?.id_medium &&
          user?.templo?.in_templo_ativo == 1 &&
          user?.templo?.id_medium_presidente === user?.id_medium
        ) {
          is_presidente = true
        }
        console.log('1: VALIDOU ACESSO')
        resolve([user, escala_valida, has_message, error, is_presidente])
      })
    })
  }

  //[user, escala_valida, has_message, error, is_presidente]
  function validarTemploAtivo(elements: any) {
    return new Promise((resolve, reject) => {
      if (!elements[3] && elements[0]?.templo?.in_templo_ativo != 1) {
        elements[2] = 'Templo está INATIVO! Entre em contato com Administrador'
        elements[3] = true
        console.log('2: VALIDOU TEMPLO: INATIVO')
      }
      console.log('2: VALIDOU TEMPLO: ATIVO')
      resolve([elements[0], elements[1], elements[2], elements[3], elements[4]])
    })
  }

  //[user, escala_valida, has_message, error, is_presidente]
  function validarEscalado(elements: any) {
    return new Promise((resolve, reject) => {
      getEscalaByTemplo(elements[0]?.templo?.id_templo || 0)
        .then((res) => {
          console.log('3: VALIDOU ESCALADO')
          resolve([elements[0], elements[1], elements[2], elements[3], elements[4], res])
        })
        .catch((error) => {
          console.error('Erro ao validar escalado:', error)
          // Retornar array vazio em case de erro
          resolve([elements[0], elements[1], elements[2], elements[3], elements[4], {data: []}])
        })
    })
  }

  //[user, escala_valida, has_message, error, is_presidente, escalas]
  function validarEscala(elements: any) {
    return new Promise((resolve, reject) => {
      try {
        // Verificar se elements[5] e elements[5].data existem
        if (!elements[5] || !elements[5].data) {
          console.log('DEVAS NAO ESCALADO - Sem dados de escala')
          elements[1] = false
          console.log('4: VALIDOU ESCALA (sem dados)')
          resolve([elements[0], elements[1], elements[2], elements[3], elements[4], elements[5]])
          return
        }

        let escalaFound = elements[5].data
          .filter(
            (escala: EscalaDevas) => escala.devas_escalado?.id_medium == elements[0]?.id_medium
          )
          .map((escala: EscalaDevas) => {
            if (escala) {
              var compareDate = moment(moment(), 'DD/MM/YYYY')
              var startDate = moment(
                newDateUserTimezoneOffsetMinus(escala.init_date),
                'DD/MM/YYYY'
              )
              var endDate = moment(newDateUserTimezoneOffsetMinus(escala.end_date), 'DD/MM/YYYY')

              if (compareDate.isBefore(startDate) || compareDate.isAfter(endDate)) {
                elements[1] = false
                console.log('ESCALA FORA DE DATA')
              } else {
                elements[1] = true
                console.log('ESCALA VALIDA')
              }
            } else {
              console.log('DEVAS NAO ESCALADO')
            }
          })
        console.log('4: VALIDOU ESCALA')
        resolve([elements[0], elements[1], elements[2], elements[3], elements[4], elements[5]])
      } catch (error) {
        console.error('Erro ao validar escala:', error)
        elements[1] = false
        resolve([elements[0], elements[1], elements[2], elements[3], elements[4], elements[5]])
      }
    })
  }

  //[user, escala_valida, has_message, error, is_presidente, escalas]
  function lancarError(elements: any) {
    return new Promise((resolve, reject) => {
      console.log('escala_valida: ', elements[1])
      //validar escala somente templo mae
      if (!elements[3] && !elements[1] && elements[0]?.templo?.id_templo === 1) {
        elements[2] = 'Usuário Devas não escalado!'
        elements[3] = true
      }

      if (elements[3] && !is_autorizado && !elements[4]) {
        //acesso negado: exibe a tela de bloqueio com o motivo e desconecta em seguida
        setMensagemNegado(elements[2])
        setAcesso('negado')
        creatToastError(elements[2])
        setTimeout(() => {
          keycloak.logout()
          localStorage.setItem('key_id_templo', '')
          localStorage.setItem('key_id_medium_login', '')
        }, 3000)
      } else {
        //seta o templo
        localStorage.setItem(
          'key_id_templo',
          is_autorizado ? '1' : elements[0]?.templo?.id_templo + ''
        )
        localStorage.setItem(
          'key_id_medium_login',
          is_autorizado ? keycloak.tokenParsed?.email : elements[0]?.id_medium
        )
        setAcesso('liberado')
      }
      console.log('5: TRATOU ERRO')
      resolve([elements[0], elements[1], elements[2], elements[3], elements[4], elements[5]])
    })
  }

  const creatToastError = (has_message: string) => {
    toast.error(has_message, {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    })
  }

  //enquanto valida o acesso, não renderiza o layout nem as telas privadas
  if (acesso === 'validando') {
    return (
      <div className='d-flex flex-column justify-content-center align-items-center min-vh-100'>
        <span className='spinner-border spinner-border-lg text-primary'></span>
        <span className='mt-4 text-muted fw-semibold fs-5'>Validando acesso...</span>
      </div>
    )
  }

  //acesso negado: tela de bloqueio com o motivo; o logout ocorre em instantes
  if (acesso === 'negado') {
    return (
      <>
        <div className='d-flex flex-column justify-content-center align-items-center min-vh-100 px-5'>
          <div className='alert alert-danger d-flex align-items-center py-5 px-8 mb-0'>
            <i className='bi bi-exclamation-triangle-fill fs-2x me-4'></i>
            <div>
              <div className='fw-bolder fs-4'>{mensagemNegado}</div>
              <div className='fs-7 mt-1'>Você será desconectado em instantes.</div>
            </div>
          </div>
          <span className='spinner-border spinner-border-lg text-primary mt-8'></span>
        </div>
        <ToastContainer autoClose={2000} />
      </>
    )
  }

  return (
    <>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          <Route path='auth/*' element={<Navigate to='/app/dashboard' />} />

          {/* Pages */}
          <Route path='app/dashboard' element={<DashboardWrapper />} />

          {/* Lazy Modules */}

          {AuthorizedFunction(['operacional-devas']) && (
            <Route
              path='app/enroll/medium/:number/*'
              element={
                <SuspensedView>
                  <MediumPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-sistema', 'autorizador-cadastro']) && (
            <Route
              path='app/enroll/templo/:number/*'
              element={
                <SuspensedView>
                  <TemploPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['operacional-devas']) && (
            <Route
              path='app/management/medium/*'
              element={
                <SuspensedView>
                  <PesquisaMediumPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-sistema', 'autorizador-cadastro']) && (
            <Route
              path='app/management/templo/*'
              element={
                <SuspensedView>
                  <PesquisaTemploPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-sistema', 'autorizador-cadastro']) && (
            <Route
              path='app/management/devas/*'
              element={
                <SuspensedView>
                  <SalaDevasPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-sistema']) && (
            <Route
              path='app/management/falange/*'
              element={
                <SuspensedView>
                  <FalangePage />
                </SuspensedView>
              }
            />
          )}

          <Route
            path='app/management/adjunto/*'
            element={
              <SuspensedView>
                <AdjuntoPage />
              </SuspensedView>
            }
          />

          <Route
            path='app/management/legiao/*'
            element={
              <SuspensedView>
                <LegiaoPage />
              </SuspensedView>
            }
          />

          {AuthorizedFunction(['admin-sistema']) && (
            <Route
              path='app/carteirinha/view/:id'
              element={
                <SuspensedView>
                  <CarteirinhaPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-sistema']) && (
            <Route
              path='app/carteirinha/*'
              element={
                <SuspensedView>
                  <PesquisaCarteirinhaPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-master']) && (
            <Route
              path='app/management/aprovacoes/*'
              element={
                <SuspensedView>
                  <AprovacoesFichaPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-master']) && (
            <Route
              path='app/management/usuarios-keycloak/*'
              element={
                <SuspensedView>
                  <UsuariosKeycloakPage />
                </SuspensedView>
              }
            />
          )}

          {AuthorizedFunction(['admin-sistema']) && (
            <Route
              path='app/management/relatorios/*'
              element={
                <SuspensedView>
                  <RelatoriosPage />
                </SuspensedView>
              }
            />
          )}

          {/* Page Not Found */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
      <ToastContainer autoClose={2000} />
    </>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
